import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";

export const GET_ARTEFILES = 'GET_ARTEFILES'
export const DELETE_ARTEFILE = 'DELETE_ARTEFILE'

export const getArteFiles = () => {
    const offset = 0;
    const limitSize = 100;
    return (dispatch) => {
        axios.get(`${serverUrl.Artefacts}?offset=${offset}&limitsize=${limitSize}`)
        .then(response => {
            if (response.status === 200) {
                const files = response.data.results;
                dispatch({ type: GET_ARTEFILES, files })
            }
        })
    }
    
}

export const deleteArteFile = (fileId) => {
    return (dispatch) => {
        axios.delete(`${serverUrl.Artefacts}/${fileId}`)
        .then(response => {
            if (response.status === 200) {

                dispatch({ type: DELETE_ARTEFILE })
                
                
            }
        })
    }
    
}